import { Container } from '@weareconceptstudio/core';
import Item from '../Item';

const AnimItems = ({ list, percent, className = '' }) => {
	return (
		<Container>
			<div className={`infinite-inner-wrapper position-wrapper anim-wrapper ${className}`}>
				{list.map((item, i) => (
					<Item
						key={`${item.slug}+${i}`}
						item={item}
						index={i}
						percent={percent}
						isAnimationList
					/>
				))}
			</div>
		</Container>
	);
};

export default AnimItems;
